export const projects = [
  {
    title: "Credit Card Approval System",
    description:
      " Building a probabilistic statistical model that looks into historical data to find patterns in what parameters lie in decision making behind the approval of a credit model, deploying a trained model. Maven's AI cron job does the predictions and sends it back to the bank.",
    image: "/images/3.png",
    tags: ["Python", "Machine Learning"],
    source: "https://google.com",
    visit: "https://github.com/Soujannya16/CreditCardApprovalSystem",
    id: 2,
  },

  {
    title: "Diabetes Onset Prediction",
    description:
      "This was the final year project of my BTech. The objective of this research is to make use of significant features, design a prediction algorithm using Deep learning and find the optimal classifier to give the closest result comparing to clinical outcomes.",
    image: "/images/2.jpg",
    tags: ["Python", "Deep Learning"],
    source: "https://google.com",
    visit: "https://github.com/Soujannya16/DiabetesOnsetPrediction",
    id: 1,
  },

  {
    title: "Online Polling System",
    description:
      "An online voting system developed using Java as backend, HTML as frontend and MySQL as the database. In this system, people of India who have citizenship and whose age is above 18 years can give their vote online without going to any physical polling station.",
    image: "/images/1.png",
    tags: ["Java", "SQL", "HTML"],
    visit: "https://github.com/Soujannya16/OnlinePollingSystem",
    // visit: 'https://google.com',
    id: 0,
  },
  {
    title: "Duty Roster",
    description:
      "This project was used to make duty roster to assign shifts to the employees in South Eastern Railway, Head Quarter, IT Centre. The duty roster is displayed in form of a table which is editable and printable. We can also export it to an Excel sheet. All the information in the table can be updated when it is required.",
    image: "/images/4.png",
    tags: ["Java"],
    source: "https://google.com",
    visit: "https://github.com/Soujannya16/DutyRoster",
    id: 3,
  },
];

export const TimeLineData = [
  {
    year: 2016,
    text: "Started my journey as a BTech student. Relevant Coursework: Data Structures, Web Development, Software Engineering, Algorithms.  ",
  },
  {
    year: 2018,
    text: "Internship at IOCL, worked on full stack development of their internal online polling system application using Java",
  },
  {
    year: 2019,
    text: "Internship at South Easter Railways, developed a tool to generate monthly duty roster for Group D staff",
  },
  {
    year: 2020,
    text: "Offered 4 jobs, qualified Gate 2020 and went for Masters in Software Engineering from Jadavpur Univsersity",
  },
  {
    year: 2021,
    text: "Worked on my Maters Thesis on Partial Image Encryption and published the same. Relevant Coursework: Distributed Sytems, Parallel Processing, System Design",
  },
  {
    year: 2022,
    text: "Started working from January as Software Developer Intern in Applied Materials for 6 months, worked in Devops and Observability",
  },
  {
    year: 2022,
    text: "Joined PwC in July as a Technology Consultant and working presently as a Front End Developer (on Website, Native Android and iOS platforms)",
  },
];

export const certificationsData = [
  {
    org: "AWS",
    text: "Certified Developer Associate",
    url: "https://www.credly.com/badges/7cf802cd-007d-405c-9bfa-4e6fff3e2574/linked_in_profile",
    credential: "J2783PKCYF411MSK",
  },
  {
    org: "Microsoft",
    text: "Certified: Azure AI Fundamentals",
    url: "https://www.credly.com/badges/8f571f54-b75c-4f9d-935d-9c574799337f?source=linked_in_profile",
  },
  {
    org: "Microsoft",
    text: "Certified: Azure Data Fundamentals",
    url: "https://www.credly.com/badges/05522b34-98d3-49a9-be8f-5a51b3d7177f?source=linked_in_profile",
  },
  {
    org: "GCP",
    text: "BigQuery Basics for Data Analysts",
    url: "https://google.qwiklabs.com/public_profiles/f59c56b5-c7b8-4f58-93e9-699e9641d753/badges/1097697",
  },
  {
    org: "GCP",
    text: "Create ML Models with BigQuery ML",
    url: "https://google.qwiklabs.com/public_profiles/f59c56b5-c7b8-4f58-93e9-699e9641d753/badges/1102130",
  },
  {
    org: "GCP",
    text: "Create and manage Cloud resources",
    url: "https://google.qwiklabs.com/public_profiles/f59c56b5-c7b8-4f58-93e9-699e9641d753/badges/1092444",
  },
  {
    org: "GCP",
    text: "Insights from Data with BigQuery",
    url: "https://google.qwiklabs.com/public_profiles/f59c56b5-c7b8-4f58-93e9-699e9641d753/badges/1098390",
  },
  {
    org: "GCP",
    text: " ... Other Certificates",
    url: "https://www.cloudskillsboost.google/public_profiles/f59c56b5-c7b8-4f58-93e9-699e9641d753",
  },
];

export const experience = [
  {
    title: "PwC India",
    description: [
      {
        project: "FMEG client",
        work: [
          " Led cross-functional teams to engineer a scalable React Native solution, reducing technical debt by 40% through collaborative code reviews and adherence to best practices.",
          " Drove app performance to a 4.4-star Google Play Store rating (334+ reviews) and 100,000+ downloads through UX optimizations and iterative feature enhancements.",
          " Accelerated KYC completion for 10,000+ users within 3 months by streamlining form workflows and integrating real-time validation.",
          " Spearheaded Firebase integration (push notifications, dynamic links, crashlytics), Google Analytics, slashing crash rates by 35% and boosting user retention by 20%.",
        ],
        links: [
          {
            title: "Visit Playstore",
            href: "https://play.google.com/store/apps/details?id=com.polycab.expert",
          },
          {
            title: "Visit Appstore",
            href: "https://apps.apple.com/in/app/polycab-experts-loyalty/id6472480126",
          },
        ],
      },
      {
        project: "Edutech client",
        work: [
          "Contributing to the design and implementation of multiple React UI components for a feature-rich user experience",
          "Using React Native to develop UI for applications (iOS and Android)",
          "Increased the rating of Google Play app by 24%",
          "Integration with backend APIs with backend in Java springboot.",
          "Explored and adopted open-source libraries and tools for various development tasks.",
          "Participating in debugging, testing, and code optimization efforts.",
          "Implementing performance optimizations to enhance the speed andresponsiveness of web applications.",
          "Demonstrated involvement in the complete software development lifecycle, from gathering client requirements to deploying applications on servers, showcasing a holistic understanding of project management and delivery.",
        ],
        links: [
          {
            title: "Visit Site 1",
            href: "https://bhis.lighthouse-learning.com",
          },
          {
            title: " Visit Site 2",
            href: " https://eurokids.lighthouse-learning.com/",
          },
          {
            title: " Visit App 1",
            href: "https://play.google.com/store/apps/details?id=com.lighthouse.argus",
          },
          {
            title: " Visit App 2",
            href: "https://play.google.com/store/apps/details?id=com.homebuddyLearning",
          },
        ],
      },
      {
        project: "Internal Project",
        work: [
          "Developed API endpoints and microservices in Node.js to handle service requests from employees",
        ],
      },
    ],
    image: "/images/pwc.jpg",
    tags: [
      "React.js",
      "Node.js",
      "TypeScript",
      "Javascript ES6",
      "React Native",
      "Java springboot",
    ],
    role: "Technology Consultant",
    duration: "July 2022 - Present",
    id: 2,
  },

  {
    title: "Applied Materials",
    description: [
      {
        project: "",
        work: [
          "  Collaborated with the platform team to develop and optimize web applications,using (CI/CD) tool Jenkins to automate build and deployment processes.",
          "Utilized Prometheus, Kibana, Grafana to monitor and analyze system metrics, enabling identification of bottlenecks and timely optimization for optimal on-premise cloud operation",
        ],
      },
    ],
    image: "/images/amat.jpg",
    tags: [
      "Docker",
      "Kubernetes",
      "Grafana",
      "Kibana",
      "Prometheus",
      "Jenkins",
    ],
    role: "SDE Intern",
    duration: "Feb 2022 - July 2022",
    id: 1,
  },
  {
    title: "South Eastern Railways",
    description: [
      {
        project: "",
        work: [
          " Built a duty roster, using Java Swing, helping IT Department employees with faster and more efficient way of holiday and shift management",
        ],
      },
    ],
    image: "/images/southEastRail.png",
    tags: ["Java Swing", "Java"],
    role: "Engineer Intern",
    duration: "June 2019 - July 2019",
    id: 0,
  },
  {
    title: "Indian Oil",
    description: [
      {
        project: "",
        work: [
          " Developed a full-stack web-based project on 'Online Polling System' using Java Servlets, the front end in HTML and CSS, backend in Java and database MySql",
        ],
      },
    ],
    image: "/images/iocl.png",
    tags: ["Java", "HTML", "CSS", "Sql"],
    role: "Developer Intern",
    duration: "December 2018 - February 2019",
    id: 0,
  },
];
export const myDesc =
  "A dedicated and versatile software engineer with a strong understanding of the modern front-end and full-stack web/native development ecosystem. Seeking a challenging role on a platform team to contribute to the development and optimization of applications, while providing excellent service to fellow engineers.";
